import * as React from "react";
import { ContentLoader } from "components";

const Skeleton: React.FC = () => (
  <div>
    <ContentLoader viewBox="0 0 1260 720">
      <rect x="0" y="30" width="1260" height="45" />
      <rect x="0" y="80" width="450" height="20" />

      <rect x="0" y="125" width="150" height="30" />
      <rect x="0" y="170" width="100" height="25" />
      <rect x="0" y="205" width="100" height="25" />
      <rect x="130" y="205" width="100" height="25" />
      <rect x="260" y="205" width="100" height="25" />
      <rect x="390" y="205" width="100" height="25" />
      <rect x="520" y="205" width="100" height="25" />
      <rect x="650" y="205" width="100" height="25" />

      <rect x="0" y="255" width="150" height="30" />
      <rect x="0" y="300" width="100" height="25" />
      <rect x="0" y="335" width="100" height="25" />
      <rect x="0" y="370" width="100" height="25" />
      <rect x="0" y="405" width="100" height="25" />

      <rect x="430" y="255" width="150" height="30" />
      <rect x="430" y="300" width="100" height="25" />
      <rect x="430" y="335" width="100" height="25" />
      <rect x="430" y="370" width="100" height="25" />
      <rect x="430" y="405" width="100" height="25" />

      <rect x="860" y="255" width="150" height="30" />
      <rect x="860" y="300" width="100" height="25" />
      <rect x="860" y="335" width="100" height="25" />
      <rect x="860" y="370" width="100" height="25" />
      <rect x="860" y="405" width="100" height="25" />

      <rect x="0" y="455" width="150" height="30" />
      <rect x="0" y="490" width="1260" height="45" />

      <rect x="0" y="560" width="150" height="30" />
      <rect x="0" y="595" width="1260" height="45" />

      <rect x="880" y="665" width="120" height="45" />
      <rect x="1010" y="665" width="120" height="45" />
      <rect x="1140" y="665" width="120" height="45" />
    </ContentLoader>
  </div>
);

export default Skeleton;
